import React from 'react';
import {NavLink} from 'react-router-dom';

import "./NavigationItem.css";

const NavigationItem = (props) => {
    return (
        <div className="NavigationItem">
            <NavLink exact to={props.link}>
                {props.children}
            </NavLink>
        </div>
    )
}

export default NavigationItem;